var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.id,staticClass:"action-table-column"},[_vm._t("default"),(_vm.showMoreButton)?_c('more-action',{attrs:{"actionList":_vm.filterActionList,"addKey":_vm.addKey}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }